export const SET_PERMISSION_LIST = 'permissionList';
export const SET_USER_INFO = 'USER_INFO';